module.exports = __webpack_public_path__ + "img/playing-music-animate.443b106e.svg";